import { QueryClient } from '@tanstack/react-query';

/**
 * The app's single React Query client.
 *
 * It lives here rather than in App.tsx so non-React code can reach it. The
 * onboarding tour needs exactly that: seeding and cleanup create and delete
 * sample rows straight on the backend, and the service that drives them has to
 * drop the cached lists those rows are sitting in without a hook or a provider.
 */
export const queryClient = new QueryClient();
